import {
  PREMIUM_CALCULATE,
  PREMIUM_CALCULATE_CLEAR_DATA,
  PREMIUM_CALCULATE_ERROR,
  PREMIUM_CALCULATE_SUCCESS,
} from "./actionTypes";

//aqui inicia el post
export const premiumCalculatePost = (calculateBody) => {
  return {
    type: PREMIUM_CALCULATE,
    payload: { calculateBody },
  };
};

export const premiumCalculatePostSuccess = (success) => {
  return {
    type: PREMIUM_CALCULATE_SUCCESS,
    payload: success,
  };
};

export const premiumCalculatePostError = (error) => {
  return {
    type: PREMIUM_CALCULATE_ERROR,
    payload: error,
  };
};

export const premiumCalculatePostClearData = () => {
  return {
    type: PREMIUM_CALCULATE_CLEAR_DATA,
    payload: {},
  };
};
